import { GET, POST } from "../../../module/services/fetch";
import { map } from "rxjs/operators";

export const fetchReportsRequest = () =>
  GET(`reports`).pipe(map((response: any) => response));

export const fetchReportGeneration = (payload: any) => {
  const reportId = payload.reportId;
  const body = payload.body;
  return POST(`reports/${reportId}/generate`, body).pipe(
    map((response: any) => response)
  );
};

export const fetchCampaignNames = () =>
  GET(`recertification/instances/recertificationNames`).pipe(
    map((response: string[]) => response)
  );
